import { DEFAULT_PRIMARY_COLOR } from '@/constants';
import { ReportData, Psychologist } from './types';
import { getTextColorForBackground } from '@/utils/getTextColorForBackground';

interface ReportFooterProps {
    data: ReportData;
    currentPage: number;
    totalPages: number;
    psychologist: Psychologist | null;
}

export function ReportFooter({ data, currentPage, totalPages, psychologist }: ReportFooterProps) {
    const footerConfig = data.customizations?.footer;
    const colors = data.customizations?.colors;

    const primaryColor = colors?.primary || DEFAULT_PRIMARY_COLOR;
    const padding = footerConfig?.padding || 12;

    return (
        <>
            <div className="text-center text-xs text-slate-400 py-2">
                Página {currentPage} de {totalPages}
            </div>

            <div
                className="px-6"
                style={{
                    backgroundColor: primaryColor,
                    color: getTextColorForBackground(primaryColor),
                    paddingTop: `${padding}px`,
                    paddingBottom: `${padding}px`,
                }}
            >
                <div className="flex items-center justify-between text-xs">
                    {!!footerConfig?.phone_number_visible && psychologist?.phone && (
                        <div>{psychologist.phone}</div>
                    )}
                    {!!footerConfig?.psychologist_name_visible && (
                        <div className="text-center">
                            {psychologist?.full_name || 'Nome do Psicólogo'}
                        </div>
                    )}
                    {!!footerConfig?.email_visible && (
                        <div>{psychologist?.email || 'email@exemplo.com'}</div>
                    )}
                    {!!footerConfig?.instagram_visible && psychologist?.instagram && (
                        <div>{`@${psychologist.instagram.replace('@', '')}`}</div>
                    )}
                </div>
            </div>
        </>
    );
}
